export default __webpack_public_path__ + "static/media/twitter-certificate.c8356183.svg";